import { render, staticRenderFns } from "./CustomOption.vue?vue&type=template&id=ba9c4bd8&scoped=true&"
import script from "./CustomOption.vue?vue&type=script&lang=js&"
export * from "./CustomOption.vue?vue&type=script&lang=js&"
import style0 from "./CustomOption.vue?vue&type=style&index=0&id=ba9c4bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9c4bd8",
  null
  
)

export default component.exports